{
  "meta": {
    "title": "Campagnes publicitaires",
    "manageAndTrack": "Gérez les campagnes et suivez leurs performances"
  },
  "actions": {
    "addCampaign": "Ajouter une campagne",
    "view": "Voir",
    "edit": "Modifier",
    "cancel": "Annuler",
    "createCampaign": "Créer la campagne",
    "creating": "Création…",
    "payForCampaign": "Payer la campagne",
    "paying": "Paiement…",
    "actions": "Actions"
  },
  "filters": {
    "statusRunning": "En cours",
    "statusEnded": "Terminée",
    "allStatuses": "Tous les statuts"
  },
  "status": {
    "DRAFT": "Brouillon",
    "PENDING_PAYMENT": "En attente de paiement",
    "PENDING_APPROVAL": "En attente d'approbation",
    "REJECTED": "Rejetée",
    "ACTIVE": "En cours",
    "PAUSED": "En pause",
    "ENDED": "Terminée",
    "CANCELLED": "Annulée"
  },
  "lifecycle": {
    "created": "Créée",
    "paid": "Payée",
    "approved": "Approuvée",
    "live": "En ligne",
    "ended": "Terminée"
  },
  "table": {
    "image": "Image",
    "name": "Campagne",
    "service": "Service",
    "plan": "Formule",
    "status": "Statut",
    "na": "N/A",
    "searchPlaceholder": "Rechercher des campagnes…",
    "emptyTitle": "Aucune campagne",
    "emptyDescription": "Créez une campagne pour commencer à promouvoir vos services."
  },
  "create": {
    "title": "Créer une campagne",
    "description": "Créez une nouvelle campagne pour promouvoir vos services",
    "cardTitle": "Informations de campagne",
    "cardDescription": "Ajoutez le visuel, sélectionnez un service, une formule et une date de début",
    "nameLabel": "Nom de la campagne",
    "namePlaceholder": "Nom d'affichage optionnel",
    "creativeLabel": "Visuel de campagne",
    "creativeHelp": "Téléversez votre propre image ou vidéo, ou générez-en une avec l'IA",
    "creativeTabs": {
      "upload": "Téléverser depuis l'appareil",
      "generate": "Générer avec l'IA"
    },
    "uploadFromDeviceHelp": "Utilisez votre propre image ou vidéo MP4 — aucun crédit IA requis.",
    "uploadCreativeLabel": "Visuel de campagne",
    "uploadCreativeHelp": "Téléversez un PNG ou JPG (max. 3 Mo) ou une vidéo MP4 (max. 8 Mo). Ratio 16:9 recommandé.",
    "uploadPosterLabel": "Image d'aperçu",
    "uploadPosterHelp": "Image fixe affichée avant le chargement de la vidéo et dans les listes.",
    "uploading": "Téléversement…",
    "serviceLabel": "Service",
    "serviceHelp": "Sélectionnez le service promu par cette campagne",
    "servicePlaceholder": "Sélectionner un service",
    "startDateLabel": "Date de début",
    "startDateHelp": "Quand la campagne doit-elle démarrer ?",
    "adPlanLabel": "Formule publicitaire",
    "adPlanHelp": "Sélectionnez la formule de publicité",
    "adPlanPlaceholder": "Sélectionner une formule",
    "next": "Suivant",
    "back": "Retour",
    "postCreatePayHint": "Campagne créée. Payez-la pour la soumettre à approbation.",
    "steps": {
      "creative": "Visuel",
      "service": "Service et formule",
      "review": "Révision"
    },
    "errors": {
      "waitUpload": "Veuillez attendre la fin du téléversement",
      "uploadFailed": "Échec du téléversement",
      "imageRequired": "L'image de la campagne est requise",
      "videoRequired": "La vidéo de la campagne est requise",
      "posterRequired": "L'image d'aperçu est requise pour les annonces vidéo",
      "selectService": "Veuillez sélectionner un service",
      "selectPlan": "Veuillez sélectionner une formule",
      "startDateRequired": "La date de début est requise",
      "selectBusiness": "Sélectionnez une entreprise pour cette campagne",
      "createFailed": "Échec de la création de la campagne"
    },
    "toasts": {
      "createdSuccess": "Campagne créée avec succès"
    },
    "uploadingProgress": "Téléversement… {{progress}} %",
    "currentCreativeLabel": "Visuel actuel",
    "currentCreativeImage": "Image fixe prête pour cette campagne.",
    "currentCreativeVideo": "Publicité animée prête pour cette campagne.",
    "removeCreative": "Retirer"
  },
  "show": {
    "title": "Détails de la campagne",
    "notFoundTitle": "Campagne introuvable",
    "invalidId": "ID de campagne invalide",
    "campaignNotFound": "Campagne introuvable.",
    "backToCampaigns": "Retour aux campagnes",
    "description": "Consultez les performances et les éléments de la campagne",
    "service": "Service",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "creativeAlt": "Visuel de campagne",
    "uploading": "Téléversement…",
    "rejectionReason": "Motif du rejet",
    "payoutStatus": "Versement",
    "payoutPaid": "Revenus versés à l'entreprise",
    "metrics": {
      "views": "Vues",
      "viewsDesc": "Nombre de vues dans le temps",
      "clicks": "Clics",
      "clicksDesc": "Nombre de clics dans le temps",
      "ctr": "Taux de clics"
    },
    "status": {
      "running": "En cours",
      "ended": "Terminée",
      "awaitingApproval": "En attente d'approbation",
      "awaitingPayment": "En attente de paiement"
    },
    "payment": {
      "confirmed": "Paiement de la campagne confirmé",
      "processing": "Le paiement peut encore être en cours. Actualisez cette page sous peu.",
      "failedUrl": "Impossible d'obtenir l'URL de paiement",
      "failedPay": "Échec du paiement de la campagne"
    },
    "image": {
      "updatedSuccess": "Image mise à jour avec succès",
      "updateFailed": "Échec de la mise à jour de l'image",
      "confirmTitle": "Mettre à jour l'image de la campagne ?",
      "confirmDescription": "Changer l'image réinitialise l'approbation. Votre campagne devra être examinée à nouveau.",
      "confirmAction": "Mettre à jour l'image"
    },
    "creativeUnavailable": "Visuel indisponible"
  },
  "edit": {
    "title": "Modifier la campagne",
    "description": "Mettez à jour le visuel de la campagne",
    "detailsTitle": "Détails de la campagne",
    "detailsDescription": "Modifiez le nom, le calendrier et la formule avant le paiement.",
    "saveDetails": "Enregistrer les détails",
    "cardTitle": "Image de la campagne",
    "cardDescription": "Téléversez une nouvelle image (ratio 16:9 recommandé)",
    "creativeLabel": "Visuel de campagne",
    "creativeHelp": "Remplacez l'image actuelle",
    "paidDetailsHint": "Les détails ne peuvent pas être modifiés après le paiement. Vous pouvez toujours remplacer l'image de la campagne.",
    "saveChanges": "Enregistrer les modifications",
    "reviewDescription": "Vérifiez vos modifications avant d'enregistrer.",
    "toasts": {
      "updatedSuccess": "Campagne mise à jour avec succès",
      "updateFailed": "Échec de la mise à jour de la campagne"
    }
  },
  "chart": {
    "selectRange": "Sélectionner la période",
    "daily": "Quotidien",
    "monthly": "Mensuel",
    "yearly": "Annuel",
    "value": "Valeur"
  },
  "admin": {
    "pendingTitle": "Campagnes en attente",
    "pendingDescription": "Campagnes payées en attente d'approbation",
    "summaryPending": "En attente",
    "summaryActive": "Actives",
    "summaryRevenue": "Revenus ce mois",
    "review": "Examiner",
    "approve": "Approuver",
    "reject": "Rejeter",
    "rejectionReasonLabel": "Motif du rejet",
    "auditLog": "Journal d'audit"
  },
  "aiCredits": {
    "imageBalance": "{{count}} crédits image · {{price}} GHS chacun",
    "motionBalance": "{{count}} crédits motion · {{price}} GHS chacun",
    "buyImageTitle": "Acheter des crédits image",
    "buyMotionTitle": "Acheter des crédits motion",
    "buyImageDescription": "Les crédits image sont utilisés lorsque vous générez une annonce fixe avec l'IA — un crédit par variante demandée.",
    "buyMotionDescription": "Les crédits motion sont utilisés lorsque vous générez une annonce animée avec l'IA — un crédit par variante demandée.",
    "quantityLabel": "Quantité",
    "decreaseQuantity": "Diminuer la quantité",
    "increaseQuantity": "Augmenter la quantité",
    "totalCostLabel": "Total",
    "totalCost": "{{total}} GHS",
    "costBreakdown": "{{quantity}} crédits × {{price}} GHS l'unité",
    "priceUnavailable": "Prix indisponible. Réessayez bientôt.",
    "buyButton": "Payer avec Paystack",
    "buyImageCredits": "Acheter crédits image",
    "purchaseImageCredits": "Acheter des crédits image",
    "purchaseMotionCredits": "Acheter des crédits motion",
    "buyMotionCredits": "Acheter crédits motion",
    "purchaseSuccess": "Crédits ajoutés à votre solde",
    "purchaseProcessing": "Le paiement peut encore être en cours. Actualisez bientôt.",
    "purchaseFailed": "Échec du démarrage de l'achat de crédits",
    "referenceLabel": "Image de référence (optionnel)",
    "referenceHelp": "Téléversez une photo produit ou un logo à redesigner ou animer avec l'IA",
    "referenceReady": "Référence téléversée",
    "referenceUploadFailed": "Échec du téléversement de la référence",
    "imagePanelTitle": "Générer une annonce statique",
    "motionPanelTitle": "Générer une annonce animée",
    "headlineLabel": "Titre",
    "styleLabel": "Notes de style",
    "promptLabel": "Prompt",
    "promptHelp": "Décrivez l'annonce souhaitée : offre, ton, audience.",
    "motionPromptLabel": "Prompt de mouvement",
    "motionPromptHelp": "Décrivez un mouvement subtil (zoom, shimmer, produit).",
    "motionDefaultPrompt": "Mouvement promotionnel subtil, boucle, style publicitaire professionnel",
    "motionDurationHint": "Génère une boucle MP4 silencieuse de 5 secondes pour le carrousel.",
    "variantCountLabel": "Variantes",
    "generateImage": "Générer avec l'IA",
    "generateMotion": "Générer annonce animée",
    "generating": "Génération…",
    "generatingMotion": "Génération vidéo…",
    "generationFailed": "Échec de la génération",
    "variantAlt": "Variante {{index}}",
    "variantSelected": "Créatif sélectionné",
    "motionSelected": "Annonce animée sélectionnée",
    "uploadSelectedFailed": "Échec de l'enregistrement du créatif",
    "animateThis": "Animer cette image",
    "sourcePreviewAlt": "Image source pour le motion",
    "mediaTypeImage": "Image",
    "mediaTypeMotion": "Vidéo",
    "generatingHint": "Création de vos variantes. Cela prend généralement moins d'une minute.",
    "motionGeneratingHint": "Rendu de votre vidéo. Cela peut prendre quelques minutes — gardez cet onglet ouvert.",
    "selectVariantHint": "Choisissez une variante pour l'utiliser comme visuel publicitaire.",
    "selectMotionHint": "Choisissez une variante pour l'utiliser comme publicité animée.",
    "selectedBadge": "Sélectionnée",
    "savingVariant": "Enregistrement…",
    "savingMotion": "Enregistrement de la vidéo…",
    "preparingAnimate": "Préparation…",
    "sourceUnavailable": "Aperçu de la source indisponible. Générez ou téléversez de nouveau l'image.",
    "generationTimeout": "La génération a expiré. Réessayez — cela peut prendre quelques minutes."
  },
  "composer": {
    "title": "Créez votre visuel publicitaire",
    "subtitle": "Partez d'un modèle, décrivez ce que vous voulez, ou téléversez le vôtre.",
    "placeholder": "Décrivez la publicité souhaitée. Précisez l'offre, le ton et l'audience.",
    "motionPlaceholder": "Décrivez le mouvement souhaité — zoom, scintillement, mouvement du produit.",
    "generate": "Générer",
    "attach": "Ajouter un fichier",
    "uploadOwn": "Téléverser ma publicité",
    "addReference": "Ajouter une image de référence",
    "variants": "{{count}} variante",
    "variants_other": "{{count}} variantes",
    "addDetails": "Ajouter titre et style",
    "hideDetails": "Masquer titre et style",
    "startOver": "Recommencer",
    "outOfImageCredits": "Vous n'avez plus de crédits image. Achetez-en ou téléversez votre propre publicité.",
    "outOfMotionCredits": "Vous n'avez plus de crédits animation. Achetez-en ou téléversez votre propre publicité."
  },
  "templates": {
    "productShowcase": {
      "title": "Vitrine produit",
      "prompt": "Une prise de vue studio épurée du produit sur un socle à lumière douce, espace généreux pour le texte de l'offre, moderne et haut de gamme.",
      "style": "Éclairage studio, minimal, fort contraste",
      "motionPrompt": "Un lent zoom avant sur le produit avec une lumière douce qui balaie la surface, calme et haut de gamme, adapté à la boucle."
    },
    "foodDrink": {
      "title": "Restauration",
      "prompt": "Une vue en plongée appétissante du plat, ingrédients frais autour de l'assiette, lumière naturelle chaude, espace en haut pour un titre.",
      "style": "Chaleureux, appétissant, lumière naturelle",
      "motionPrompt": "Une vapeur légère qui monte et un lent panoramique sur la table, chaleureux et engageant, adapté à la boucle."
    },
    "flashSale": {
      "title": "Vente flash",
      "prompt": "Une bannière promotionnelle audacieuse annonçant une remise limitée, grand pourcentage, couleurs énergiques, appel à l'action clair.",
      "style": "Audacieux, énergique, aplats de couleur",
      "motionPrompt": "Un balayage lumineux rapide sur les sacs avec un léger rebond, énergique et accrocheur."
    },
    "beautySalon": {
      "title": "Beauté & salon",
      "prompt": "Une publicité beauté élégante avec un fond dégradé doux, style soigné, ambiance calme et haut de gamme, espace pour le nom du salon.",
      "style": "Doux, élégant, dégradé pastel",
      "motionPrompt": "Un doux scintillement qui parcourt le verre avec un lent mouvement, calme et élégant, adapté à la boucle."
    },
    "servicePromo": {
      "title": "Réserver un service",
      "prompt": "Une publicité conviviale promouvant une réservation en ligne simple, ton rassurant, espace clair pour le nom du service et l'appel à l'action.",
      "style": "Épuré, convivial, professionnel",
      "motionPrompt": "Un lent panoramique sur les outils avec une lumière qui évolue doucement, stable et rassurant."
    },
    "tattooStudio": {
      "title": "Tatouage & studio",
      "prompt": "Une publicité de studio chaleureuse montrant un travail soigné en cours, lumière naturelle sur brique apparente, authentique et accueillante, espace pour le nom du studio.",
      "style": "Chaleureux, lumière naturelle, rendu documentaire authentique",
      "motionPrompt": "Un lent mouvement à travers le studio avec une lumière qui évolue doucement, chaleureux et posé, adapté à la boucle."
    },
    "healthWellness": {
      "title": "Santé & bien-être",
      "prompt": "Une publicité bien-être calme et haut de gamme, rendu clinique épuré, accents dorés doux sur fond sombre, espace généreux pour l'offre.",
      "style": "Haut de gamme, épuré, doré doux sur fond sombre",
      "motionPrompt": "Une révélation lente avec de fines particules dorées et une rotation douce, calme et haut de gamme, adapté à la boucle."
    },
    "logoReveal": {
      "title": "Révélation du logo",
      "prompt": "Un mouvement subtil révélant la marque : léger zoom avec une lumière douce qui balaie, adapté à la boucle, rendu publicitaire professionnel.",
      "style": "",
      "motionPrompt": "Un mouvement subtil révélant la marque : léger zoom avec une lumière douce qui balaie, adapté à la boucle, rendu publicitaire professionnel."
    }
  }
}
